module.exports = __webpack_public_path__ + "static/media/about-img-two.56be8e7e.svg";